import routerOptions0 from "/builds/pro/webshop/frontend/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/builds/pro/webshop/frontend/node_modules/@xsarus-npm/nuxt-base/src/nuxt-base/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}